import { render, staticRenderFns } from "./examDetail.vue?vue&type=template&id=1a2ad51c&scoped=true"
import script from "./examDetail.vue?vue&type=script&lang=js"
export * from "./examDetail.vue?vue&type=script&lang=js"
import style0 from "./examDetail.vue?vue&type=style&index=0&id=1a2ad51c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2ad51c",
  null
  
)

export default component.exports